import { CRTRouter } from "@mike/crt";
import { useCallback, useState } from "react";
import { LoadingScreen } from "./components/LoadingScreen";
import { ReturnButton } from "./components/ReturnButton";
import { MainScene } from "./scenes/main";

// Room ambient gradient - matches the 3D scene fog color
const roomGradient = `
  radial-gradient(ellipse at 50% 40%, rgba(30, 25, 50, 0.5) 0%, transparent 60%),
  linear-gradient(180deg, #0a0812 0%, #0a0812 100%)
`;

export default function App() {
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const [showLoadingScreen, setShowLoadingScreen] = useState(true);
  const [startAnimation, setStartAnimation] = useState(false);
  const [cameraMoved, setCameraMoved] = useState(false);
  const [returnToHome, setReturnToHome] = useState(false);

  const handleReturnClick = useCallback(() => {
    setReturnToHome(true);
  }, []);

  const handleReturnComplete = useCallback(() => {
    setReturnToHome(false);
    setCameraMoved(false);
  }, []);

  const handleAssetsLoaded = useCallback(() => {
    // Assets are loaded, start fading out the loading screen
    setAssetsLoaded(true);
  }, []);

  const handleLoadingFadeOutComplete = useCallback(() => {
    // Loading screen has fully faded out, now start the camera animation
    setShowLoadingScreen(false);
    setStartAnimation(true);
  }, []);

  return (
    <>
      {showLoadingScreen && (
        <LoadingScreen
          isVisible={!assetsLoaded}
          onFadeOutComplete={handleLoadingFadeOutComplete}
        />
      )}
      <CRTRouter transitionDuration={350}>
        <div
          className="crt-container"
          style={{
            position: "fixed",
            inset: 0,
            overflow: "hidden",
            background: roomGradient,
          }}
        >
          <MainScene
            onAssetsLoaded={handleAssetsLoaded}
            startAnimation={startAnimation}
            onCameraMoved={setCameraMoved}
            cameraMoved={cameraMoved}
            returnToHome={returnToHome}
            onReturnComplete={handleReturnComplete}
            onReturn={handleReturnClick}
          />
          <ReturnButton
            onClick={handleReturnClick}
            visible={cameraMoved && !returnToHome}
          />
        </div>
      </CRTRouter>
    </>
  );
}
